"use client"

import React, { createContext, useContext, useState, ReactNode } from "react"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { DemoForm } from "@/components/demo-form"

interface DemoModalContextType {
  openDemoModal: () => void
  closeDemoModal: () => void
  isDemoModalOpen: boolean
}

const DemoModalContext = createContext<DemoModalContextType | undefined>(undefined)

export function useDemoModal() {
  const context = useContext(DemoModalContext)
  if (context === undefined) {
    throw new Error("useDemoModal must be used within a DemoModalProvider")
  }
  return context
}

export function DemoModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openDemoModal = () => setIsOpen(true)
  const closeDemoModal = () => setIsOpen(false)

  return (
    <DemoModalContext.Provider value={{ openDemoModal, closeDemoModal, isDemoModalOpen: isOpen }}>
      {children}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="sm:max-w-[600px] bg-white/95 backdrop-blur-xl">
          <DialogHeader>
            <DialogTitle className="text-center text-2xl font-light">Schedule a demo</DialogTitle>
          </DialogHeader>
          <div className="py-4">
            <DemoForm />
          </div>
        </DialogContent>
      </Dialog>
    </DemoModalContext.Provider>
  )
}
